// Pure helpers for orders.pin_labels — the free-text labels drawn under an
// order's pin on the dispatch plan map.
//
// The cap lives here rather than in the database: validating each element of a
// text[] needs unnest(), and a Postgres CHECK constraint cannot contain a
// subquery. See the order_pin_labels migration in onward-hasura.
export const MAX_PIN_LABEL_LENGTH = 20;

// Trim first, then truncate: " fragile " should become "fragile", not lose a
// trailing character to the cap it never actually exceeded.
export const normalizePinLabel = (raw) =>
    String(raw ?? '')
        .trim()
        .slice(0, MAX_PIN_LABEL_LENGTH);

// Returns `labels` unchanged (same reference) when there is nothing to add, so
// callers can skip the write. That matters because the input commits on blur:
// tabbing past an empty field, or re-blurring after an Enter, must not mark the
// edit modal dirty.
export const appendPinLabel = (labels, raw) => {
    const existing = labels || [];
    const next = normalizePinLabel(raw);

    if (!next) {
        return existing;
    }

    // Case-insensitive: "Fragile" and "fragile" would render as two identical
    // boxes under the pin, which reads as a bug rather than a distinction.
    const folded = next.toLowerCase();
    if (existing.some((label) => normalizePinLabel(label).toLowerCase() === folded)) {
        return existing;
    }

    return [...existing, next];
};

export const removePinLabel = (labels, index) => (labels || []).filter((_, i) => i !== index);
